export default () => ({
  isInitialized: false,

  init() {
    this.initCategoryHover();
    this.initTabSwitching();

    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.initCategoryHover();
      }, 250);
    });
  },

  initCategoryHover() {
    if (window.innerWidth < 1024) {
      const collectionSection = document.querySelector(
        'section[role="region"][aria-label="Category Collection"]'
      );
      if (collectionSection) {
        const overlay = collectionSection.querySelector(
          ".category-hover-overlay"
        );
        if (overlay) overlay.remove();
      }
      this.isInitialized = false;
      return;
    }

    if (this.isInitialized) return;
    this.isInitialized = true;

    const textElement = this.$el;
    const collectionSection = textElement.closest(
      'section[role="region"][aria-label="Category Collection"]'
    );
    if (!collectionSection) return;

    const tabPanel = textElement.closest('[role="tabpanel"]');
    const isFirstBlockInTab =
      tabPanel &&
      textElement === tabPanel.querySelector(".category-hover-trigger");

    if (isFirstBlockInTab) {
      const allTabPanels =
        collectionSection.querySelectorAll('[role="tabpanel"]');
      const isFirstTab =
        allTabPanels.length > 0 && tabPanel === allTabPanels[0];

      if (isFirstTab) {
        setTimeout(() => {
          this.showMediaOverlay(textElement);
        }, 100);
      }
    }

    setTimeout(() => {
      this.setFirstTextActive();
    }, 100);
  },

  initTabSwitching() {
    if (this.tabSwitchingInitialized) return;
    this.tabSwitchingInitialized = true;

    setTimeout(() => {
      const collectionSection = document.querySelector(
        'section[role="region"][aria-label="Category Collection"]'
      );
      if (collectionSection?.__x?.switchTab) {
        const originalSwitchTab = collectionSection.__x.switchTab;
        collectionSection.__x.switchTab = function (index) {
          originalSwitchTab.call(this, index);

          setTimeout(() => {
            const activeTabPanel = collectionSection.querySelector(
              '[role="tabpanel"]:not([x-cloak])'
            );
            const firstCategoryContent = activeTabPanel?.querySelector(
              ".category-hover-trigger"
            );
            if (firstCategoryContent) {
              firstCategoryContent.dispatchEvent(new Event("mouseenter"));
            }
          }, 300);
        };
      }
    }, 500);
  },

  updateActiveText(activeElement) {
    const collectionSection = this.$el.closest(
      'section[role="region"][aria-label="Category Collection"]'
    );
    const allTriggers = collectionSection.querySelectorAll(
      ".category-hover-trigger"
    );

    allTriggers.forEach((trigger) => {
      trigger.classList.remove("text-black");
      trigger.classList.add("text-[#C8C8C8]");
    });

    if (activeElement) {
      activeElement.classList.remove("text-[#C8C8C8]");
      activeElement.classList.add("text-black");
    }
  },

  showMediaOverlay(element) {
    this.updateActiveText(element);

    const collectionSection = element.closest(
      'section[role="region"][aria-label="Category Collection"]'
    );
    const existingOverlay = collectionSection.querySelector(
      ".category-hover-overlay"
    );
    if (existingOverlay) existingOverlay.remove();

    const overlay = document.createElement("div");
    overlay.className =
      "category-hover-overlay absolute top-0 right-0 w-1/2 h-full bg-white opacity-0 transition-opacity duration-300 z-50 pointer-events-none";

    const mediaType = element.dataset.mediaType;
    const videoDesktop = element.dataset.hoverVideoDesktop;
    const mediaDesktop = element.dataset.hoverMediaDesktop;

    let mediaContent = "";
    if (mediaType === "video" && videoDesktop) {
      if (videoDesktop.includes(".m3u8")) {
        mediaContent = `<video class="w-full h-full object-cover" autoplay loop muted playsinline>
          <source src="${videoDesktop}" type="application/x-mpegURL">
        </video>`;

        if (!window.hlsScriptLoaded) {
          const hlsScript = document.createElement("script");
          hlsScript.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
          hlsScript.onload = function () {
            const videos = document.querySelectorAll(
              'video source[type="application/x-mpegURL"]'
            );
            videos.forEach((source) => {
              const video = source.parentElement;
              if (Hls.isSupported()) {
                const hls = new Hls();
                hls.loadSource(source.src);
                hls.attachMedia(video);
              } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
                video.src = source.src;
              }
            });
          };
          document.head.appendChild(hlsScript);
          window.hlsScriptLoaded = true;
        }
      } else {
        mediaContent = `<video class="w-full h-full object-cover" autoplay loop muted playsinline>
          <source src="${videoDesktop}" type="video/mp4">
        </video>`;
      }
    } else if (mediaType === "image" && mediaDesktop) {
      mediaContent = `<img src="${mediaDesktop}&width=1200" alt="" class="w-full h-full object-cover">`;
    }

    if (mediaContent) {
      overlay.innerHTML = `<div class="w-full h-full">${mediaContent}</div>`;
      collectionSection.appendChild(overlay);

      if (
        mediaType === "video" &&
        videoDesktop &&
        videoDesktop.includes(".m3u8")
      ) {
        setTimeout(() => {
          const video = overlay.querySelector("video");
          const source = video?.querySelector(
            'source[type="application/x-mpegURL"]'
          );
          if (source && window.Hls && Hls.isSupported()) {
            const hls = new Hls();
            hls.loadSource(source.src);
            hls.attachMedia(video);
          } else if (
            source &&
            video?.canPlayType("application/vnd.apple.mpegurl")
          ) {
            video.src = source.src;
          }
        }, 100);
      }

      requestAnimationFrame(() => {
        overlay.style.opacity = "1";
      });
    }
  },

  setFirstTextActive() {
    const collectionSection = this.$el.closest(
      'section[role="region"][aria-label="Category Collection"]'
    );
    const visibleTabPanel = collectionSection.querySelector(
      '[role="tabpanel"]:not([x-cloak])'
    );
    if (visibleTabPanel) {
      const firstCategoryContent = visibleTabPanel.querySelector(
        ".category-hover-trigger"
      );
      if (firstCategoryContent) {
        this.updateActiveText(firstCategoryContent);
      }
    }
  },
});

// Global function for setting first text active (for compatibility)
window.setFirstTextActive = function () {
  const collectionSection = document.querySelector(
    'section[role="region"][aria-label="Category Collection"]'
  );
  if (collectionSection) {
    const visibleTabPanel = collectionSection.querySelector(
      '[role="tabpanel"]:not([x-cloak])'
    );
    if (visibleTabPanel) {
      const firstCategoryContent = visibleTabPanel.querySelector(
        ".category-hover-trigger"
      );
      if (firstCategoryContent) {
        const allTriggers = collectionSection.querySelectorAll(
          ".category-hover-trigger"
        );

        allTriggers.forEach((trigger) => {
          trigger.classList.remove("text-black");
          trigger.classList.add("text-[#C8C8C8]");
        });

        firstCategoryContent.classList.remove("text-[#C8C8C8]");
        firstCategoryContent.classList.add("text-black");
      }
    }
  }
};

// Global event listeners for compatibility
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(window.setFirstTextActive, 100);
  setTimeout(window.setFirstTextActive, 500);
  setTimeout(window.setFirstTextActive, 1000);
});

document.addEventListener("alpine:init", function () {
  setTimeout(window.setFirstTextActive, 100);
  setTimeout(window.setFirstTextActive, 500);
});

document.addEventListener("alpine:initialized", function () {
  setTimeout(window.setFirstTextActive, 100);
  setTimeout(window.setFirstTextActive, 500);
});
